<template>
	<div class="flex flex-col app-input-container">
		<div class="relative w-full mb-3 justify-center">
			<transition name="slide-fade" mode="out-in">
				<app-label v-if="placeholder" :for="name" color="secondary">
					{{ label }}
				</app-label>
			</transition>
			<vue-google-autocomplete
				id="map"
				ref="selectedAddress"
				classname="app-input"
				:country="['AL', 'XK']"
				types=""
				:fields="[
					'address_component',
					'adr_address',
					'business_status',
					'formatted_address',
					'geometry',
					'icon',
					'name',
					'place_id',
					'plus_code',
					'type',
					'url',
					'vicinity',
				]"
				:placeholder="placeholder"
				@placechanged="$emit('placechanged', $event)"
				v-bind="$attrs"
			/>
		</div>
	</div>
</template>

<script>
	import AppLabel from '@/components/typography/AppLabel';
	import VueGoogleAutocomplete from 'vue-google-autocomplete';

	export default {
		name: 'AppGeoSearchSelect',
		components: {
			AppLabel,
			VueGoogleAutocomplete,
		},
		emits: ['placechanged'],
		props: {
			icon: {
				type: String,
				default: null,
			},
			name: {
				type: String,
				required: true,
			},
			placeholder: {
				type: String,
				default: '',
			},
			label: {
				type: String,
				default: 'Street',
			},
		},
	};
</script>

<style scoped>
	:deep(input[placeholder]::placeholder) {
		color: #9ca3af;
		opacity: 1;
	}
</style>
